<template>
  <div class="rt-footer-wrapper">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'RtFooter'
};
</script>



// WEBPACK FOOTER //
// rtFooter.vue?08679a58